import React, { useState } from "react";
import { Card, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "utils/api";

// Layout Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Custom Components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import { Category } from "@mui/icons-material";

function AddSupportTicketCategory() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Category name is required");
      return;
    }

    setLoading(true);
    try {
      await api.post("/support-ticket-categories", formData);
      toast.success("Support ticket category created successfully!");
      navigate("/useful-corners/support-ticket-category");
    } catch (error) {
      console.error("Error creating support ticket category:", error);
      toast.error(error.response?.data?.message || "Failed to create support ticket category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox
              p={3}
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "12px 12px 0 0",
              }}
            >
              <ArgonBox display="flex" alignItems="center" gap={2}>
                <Category sx={{ fontSize: 32, color: "#fff" }} />
                <ArgonTypography variant="h5" color="white" fontWeight="bold">
                  Add Support Ticket Category
                </ArgonTypography>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox p={4}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <ArgonBox mb={2}>
                      <ArgonTypography variant="caption" fontWeight="bold" color="text">
                        Category Name *
                      </ArgonTypography>
                      <ArgonInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter category name"
                        required
                        fullWidth
                      />
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={4}>
                  <ArgonButton
                    variant="outlined"
                    color="secondary"
                    onClick={() => navigate("/useful-corners/support-ticket-category")}
                    disabled={loading}
                  >
                    Cancel
                  </ArgonButton>
                  <ArgonButton type="submit" variant="gradient" color="info" disabled={loading}>
                    {loading ? "Creating..." : "Create Category"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddSupportTicketCategory;
